import { render, staticRenderFns } from "./PageFormFrame.vue?vue&type=template&id=38c8048e&scoped=true&"
import script from "./PageFormFrame.vue?vue&type=script&lang=js&"
export * from "./PageFormFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c8048e",
  null
  
)

export default component.exports